import { apiV2 } from "./api"

const collectCharge = (invoiceId) => {
  return apiV2(`invoices/${invoiceId}/collect-charge`, {
    method: "POST",
  })
}

export { collectCharge }
